import React from "react"
import PropTypes from "prop-types"
import Redirect from "react-router-dom/Redirect"
import connect from "./connect"

class LoginRedirect extends React.Component {
    componentDidMount() {
        const { setRedirectUrl, location } = this.props

        setRedirectUrl(location.pathname)
    }

    render() {
        return <Redirect to="/login" />
    }
}

LoginRedirect.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    setRedirectUrl: PropTypes.func.isRequired,
}

export default connect(LoginRedirect)
